import { useMediaQuery } from '@mantine/hooks';
import { Box, Flex, Select } from '@mantine/core';
import InputText from 'primitives/InputText/InputText';

import { MenuData } from 'components/MenuManagement/types';
import { breakpoints } from 'styles/theme.variables';
import { SearchIconSm } from '@chownow/pantry/icons';

interface SearchHeaderProps {
  searchQuery: string;
  onSearch: (value: string) => void;
  categories: string[];
  menu: MenuData;
  activeCategoryID: string;
  onCategorySelect: (value: string | null) => void;
}

export default function SearchHeader({
  searchQuery,
  onSearch,
  categories,
  menu,
  activeCategoryID,
  onCategorySelect,
}: SearchHeaderProps) {
  const hasCategories = categories.length > 0;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.md})`);

  return (
    <Flex justify={isDesktop ? 'flex-start' : 'space-between'} align="center" gap="sm" py={0}>
      <Box style={{ width: isDesktop ? '200px' : '50%' }}>
        <Select
          value={activeCategoryID || 'Categories'}
          data={categories.map(categoryID => ({
            label: menu?.categories?.[categoryID]?.name || '',
            value: categoryID,
          }))}
          onChange={onCategorySelect}
          placeholder="Categories"
          withCheckIcon={false}
          withScrollArea={false}
          disabled={!hasCategories}
          comboboxProps={{
            position: 'bottom',
            width: 'target',
          }}
          styles={{
            wrapper: {
              cursor: hasCategories ? 'pointer' : 'default',
            },
          }}
          size="sm"
        />
      </Box>
      <Box style={{ width: isDesktop ? '200px' : '50%', flex: isDesktop ? 'none' : 1 }}>
        <InputText
          value={searchQuery}
          leftIcon={<SearchIconSm />}
          placeholder="Search"
          setValue={onSearch}
          size="sm"
          disabled={!hasCategories}
        />
      </Box>
    </Flex>
  );
}
